import React, { useState, useRef, MutableRefObject } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box, IconButton, Popover } from '@mui/material';
import { useDispatch } from 'react-redux';
import AcceptIcon from '../../../assets/icons/accept-icon';
import CancelIcon from '../../../assets/icons/cancel-icon';
import { preTableBulkOptions } from './options';
import useStyles from './styles';
import { PreFlashRecord } from '../../../store/bulk-device-flash/types';

const defaultValue = 0;

const BulkSelectActions = ({ selectedRows }: { selectedRows: PreFlashRecord[] }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectReference = useRef();
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [anchorElement, setAnchorElement] = useState<MutableRefObject<any> | undefined>(
    selectReference,
  );

  const handleClose = () => {
    setAnchorElement(undefined);
    setSelectedOption(defaultValue);
  };

  const bulkOptions = preTableBulkOptions(selectedRows, handleClose, dispatch);
  const PopoverElement = bulkOptions[selectedOption - 1]?.popover;
  const action = bulkOptions[selectedOption - 1]?.action;

  const open = Boolean(anchorElement);
  const id = open ? 'simple-popover' : undefined;

  const handleChange = (event: SelectChangeEvent<number | any>) => {
    const option = event.target.value as number;
    if (option) setSelectedOption(option);
    if (bulkOptions[option - 1]?.popover && selectReference) setAnchorElement(selectReference);
  };

  const handleConfirm = () => {
    setSelectedOption(defaultValue);
    if (action) action(selectReference);
  };

  return (
    <Box display="flex" justifyContent="center">
      {!!PopoverElement && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorElement?.current}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div className={classes.popoverContents}>{PopoverElement}</div>
        </Popover>
      )}
      <FormControl className={classes.formControl}>
        <Select
          variant="standard"
          ref={selectReference}
          id="bulk-actions-select"
          value={selectedOption}
          onChange={handleChange}
        >
          <MenuItem value={defaultValue}>
            <em className={classes.defaultSelect}>Bulk Actions</em>
          </MenuItem>
          {bulkOptions.map((option: any) => (
            <MenuItem value={option.value}>{option.title}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {action && (
        <>
          <Box display="flex">
            <IconButton id="bulk-action-confirm" onClick={() => handleConfirm()} size="large">
              <AcceptIcon />
            </IconButton>
            <IconButton
              id="bulk-action-confirm-deny"
              onClick={() => setSelectedOption(defaultValue)}
              aria-label="edit"
              size="large"
            >
              <CancelIcon />
            </IconButton>
          </Box>
        </>
      )}
    </Box>
  );
};
export default BulkSelectActions;
